import { useQuery } from "react-query";

import { getBodyShopsByPostCode } from "api/getBodyShopsByPostCode";

export const useGetBodyShopsByPostCode = (postCode: string = "") => {
  const { data, isLoading } = useQuery(
    `getBodyShopsByPostCode-${postCode}`,
    () => getBodyShopsByPostCode(postCode as string),
    {
      enabled: !!postCode && postCode.length > 2,
    }
  );

  return {
    data: data
      ? data.filter((bodyshop) => {
          if (bodyshop.enabled === false) return false;
          return true;
        })
      : [],
    isLoading,
  };
};
